// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-D":"D_dpu-detail-D__od719"};